"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _TableCellPropTypes = _interopRequireDefault(require("./TableCellPropTypes"));
const TableCell = ({
  className,
  headingLabel,
  value
}) => {
  const classes = (0, _classnames.default)('TableCell', className);
  return /*#__PURE__*/_react.default.createElement("td", {
    className: classes,
    "data-label": headingLabel
  }, /*#__PURE__*/_react.default.createElement("div", null, value));
};
var _default = exports.default = TableCell;